import { StyleSheet } from 'aphrodite';
import DIMENSIONS from '../../library/dimensions';
import COLORS from '../../library/colors';

export const sidebarCollapseSpeed = '400ms';

const styles = StyleSheet.create({
  root: {
    height: '100vh',
    position: 'fixed',
    left: 0,
    top: 0,
    bottom: 0,
    width: DIMENSIONS.sidebarWidth,
    background: '#19202b',
    overflowY: 'scroll',
    transition: `width ${sidebarCollapseSpeed}`,
    zIndex: 2,
    display: 'flex',
    flexDirection: 'column',
    userSelect: 'none'
  },
  rootCollapsed: {
    width: DIMENSIONS.sidebarWidthCollapsed,
  },
  sidebarSeparator: {
    width: DIMENSIONS.sidebarWidth
  },
  sidebarLink: {
    width: DIMENSIONS.sidebarWidth,
    height: 54,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 24,
    color: '#babdc0',
    textDecoration: 'none',
    fontWeight: 'bold',
    position: 'relative',
    ':hover': {
      background: '#222a36'
    }
  },
  sidebarLinkActive: {
    color: COLORS.kgGreen,
    background: '#131721',
    ':hover': {
      background: '#131721',
    },
    ':nth-child(1n) > span': {
      display: 'block'
    }
  },
  icon: {
    fontSize: 16,
    marginRight: 24
  },
  kiffgoLogoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: DIMENSIONS.headerHeight,
    flex: `0 0 ${DIMENSIONS.headerHeight}px`,
    paddingLeft: 32,
    background: '#262f3d',
    ':hover': {
      cursor: 'pointer',
      ':nth-child(1n) > svg': {
        color: 'rgba(255,255,255,0.64)',
      }
    }
  },

  kiffgoLogoImg: {
    height: 24,
    transition: '400ms',
    transitionDelay: '200ms'
  },
  kiffgoLogoImgCollapsed: {
    transition: '100ms',
    transitionDelay: '0ms',
    opacity: 0,
    transform: 'translate3d(0,18px,0)'
  },
  sidebarTitle: {
    transition: '300ms',
    transitionDelay: '100ms'
  },
  sidebarTitleCollapsed: {
    transition: '0ms',
    transitionDelay: '0ms',
    opacity: 0
  },
  collapseIcon: {
    fontSize: 18,
    color: 'rgba(255,255,255,0.32)',
    position: 'absolute',
    right: 26,
    transition: '150ms'
  },
  collapseIconCollapsed: {
    transform: 'rotate(180deg)'
  },
  menuListTitle: {
    color: '#d8dbde',
    paddingBottom: 24,
    paddingTop: 48,
    paddingLeft: 24,
    fontSize: 16
  },
  sidebarTooltip: {
    background: '#242a38',
    color: 'white',
    position: 'fixed',
    left: DIMENSIONS.sidebarWidthCollapsed + 12,
    zIndex: 3,
    padding: 4,
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 3,
    pointerEvents: 'none',
    opacity: 0,
    fontSize: 10,
    transition: '200ms',
    transform: 'translate3d(-4px,0,0)'
  },
  sidebarTooltipVisible: {
    opacity: 1,
    transform: 'translate3d(0,0,0)'
  },
  currentUserContainer: {
    color: '#babdc0',
    width: DIMENSIONS.sidebarWidth,
    height: 64,
    position: 'fixed',
    bottom: 0,
    left: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 16,
    borderTop: '1px solid #1f2734',
    borderTopColor: '#333d4e',
    background: '#19202b',
    transition: sidebarCollapseSpeed,
    paddingRight: 16
  },
  currentUserContainerCollapsed: {
    width: DIMENSIONS.sidebarWidthCollapsed,
    justifyContent: 'center',
    paddingRight: 0
  },
  currentUserContainerHovered: {
    cursor: 'pointer',
    background:'#1c232e',
  },
  currentUserCog: {
    fontSize: 16,
    position: 'absolute',
    left: 22,
    transition: '200ms'
  },
  currentUserName: {
    marginLeft: 46,
    fontWeight: 'bold'
  },
  caretRight: {
    position: 'absolute',
    right: 12,
    fontSize: 16,
    transition: '200ms',
    transform: 'translate3d(-4px,0,0)',
    opacity: 0
  },
  currentUserCogMove: {
    transform: 'translate3d(-6px,0,0)',
    opacity: 1
  },
  caretRightVisible: {
    transform: 'translate3d(0,0,0)',
    opacity: 1
  },
  userDropUpContainer: {
    position: 'absolute',
    left: DIMENSIONS.sidebarWidth + 16,
    bottom: 16
  },
  userDropUpContainerCollapsed: {
    left: DIMENSIONS.sidebarWidthCollapsed + 16
  }
});

export default styles;



// WEBPACK FOOTER //
// ./src/components/sidebar/sidebar-styles.js